import Parallax from 'parallax-js';

if (document.querySelector('[data-parallax-el]') && window.innerWidth >= 1025) {
  const parallaxContainer = document.querySelectorAll('[data-parallax-el]');
  parallaxContainer.forEach((elem) => {
    let parallaxInstance = new Parallax(elem);
    parallaxInstance.enable();
  });
}


AOS.init({
  offset: 50,
  delay: 10,
  duration: 700,
  easing: 'ease-in-out',
  once: true,
  startEvent: 'DOMContentLoaded',
});

const goUpBtn = document.querySelector('.go-up-button');

if (goUpBtn) {
  const threshold = window.innerHeight * 0.1;

  const toggleButton = () => {
    if (window.scrollY > threshold) {
      goUpBtn.classList.remove('is-hidden');
    } else {
      goUpBtn.classList.add('is-hidden');
    }
  };

  toggleButton();

  window.addEventListener('scroll', toggleButton);
}